import api from './api';

const pricingConfigService = {
  getComplexityWeights: async () => {
    try {
      const response = await api.get('/pricing-config/complexity');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar pesos de complexidade:', error);
      throw error;
    }
  },

  updateComplexityWeight: async (id, data) => {
    try {
      const response = await api.put(`/pricing-config/complexity/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar peso de complexidade:', error);
      throw error;
    }
  },

  getMaterialWeights: async () => {
    try {
      const response = await api.get('/pricing-config/materials');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar pesos de materiais:', error);
      throw error;
    }
  },

  updateMaterialWeight: async (id, data) => {
    try {
      const response = await api.put(`/pricing-config/materials/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar peso de material:', error);
      throw error;
    }
  },

  getMarginRules: async () => {
    try {
      const response = await api.get('/pricing-config/margin-rules');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar regras de margem:', error);
      throw error;
    }
  },

  updateMarginRule: async (id, data) => {
    try {
      const response = await api.put(`/pricing-config/margin-rules/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar regra de margem:', error);
      throw error;
    }
  },

  getPaymentConditions: async () => {
    try {
      const response = await api.get('/pricing-config/payment-conditions');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar condições de pagamento:', error);
      throw error;
    }
  },

  updatePaymentCondition: async (id, data) => {
    try {
      const response = await api.put(`/pricing-config/payment-conditions/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar condição de pagamento:', error);
      throw error;
    }
  }
};

export default pricingConfigService;